import { matchRoutes, useLocation } from 'react-router-dom';
import { Route, useAuthenticatedRoutes } from 'utils/hooks/use-routes';

const useCurrentRoute = (): Route | null => {
  const routes = useAuthenticatedRoutes();
  const location = useLocation();

  const routesForMatch = routes.map((route: Route) => {
    return { path: route.path };
  });

  const currentRoute = matchRoutes(routesForMatch, location);
  const currentRouteData = currentRoute?.[0] ? routes.find((route: Route) => route.path === currentRoute[0].route.path) || null : null;

  return currentRouteData;
};

export default useCurrentRoute;
